/* eslint-disable react/no-array-index-key */
import React from "react";
import he from "he";

export const decodeAndSplitTrace = (text?: string): React.ReactNode[] => {
    const decoded = he.decode(text || "");
    const parts = decoded.split("- ").filter((part) => part.trim() !== "");

    return parts.map((part, index) => (
        <React.Fragment key={index}>
            - {part}
            {index !== parts.length - 1 && <br />}
        </React.Fragment>
    ));
};
